/**
 * The words of a connection that closed: the notice's titles, its sentences, its buttons and the detail line under
 * it. The page chooses a title and a sentence by the close code (`disconnect.ts`); the detail line is for whoever
 * reports the close, and stays lower case with no full stop. `{code}` is the close code as digits and `{reason}`
 * what the server said with it.
 */
export const CLOSE = {
  titles: {
    disconnected: "You have been disconnected",
    elsewhere: "Playing elsewhere",
    loggedOut: "Logged out",
    naming: "Name needed",
    maintenance: "Closed for maintenance",
    lingering: "Still in the world",
    removed: "Removed from the world",
    serverFull: "The server is full",
    queueFull: "The queue is full",
  },
  sentences: {
    lost: "The connection to the server was lost.",
    closed: "The server closed the connection.",
    shuttingDown: "The server is shutting down.",
    gameUpdated: "The game has been updated. Reload to play.",
    loggedOut: "You have been logged out. Log in again.",
    refusedToken: "The server did not accept this sign-in.",
    tooFast: "Too many actions were sent too quickly.",
    notPlaced: "The server could not place your character in the world.",
    tooSlow: "The connection could not keep up with the server.",
    worldUpdated: "The world has been updated. Reload to play.",
    elsewhere: "This character joined from somewhere else, so this tab left the world.",
    quiet: "The connection went quiet, so the server closed it.",
    naming: "Your character needs a name. Reload the page to choose one.",
    maintenance: "The server has closed for maintenance.",
    lingering: "Another of your characters is still in the world.",
    removed: "A moderator removed you from the world.",
    queueFull: "The queue is full. Try again later.",
    serverFull: "The server is full right now. Try again in a moment.",
  },
  actions: {
    reconnect: "Reconnect",
    reload: "Reload",
    logIn: "Log in",
    status: "View status",
  },
  details: {
    expired: "sign-in expired",
    naming: "sign-in needs a name",
    closed: "closed: {code}",
    closedSaid: "closed: {code} {reason}",
  },
} as const;
